import { OrganizationRoles } from "@/shared/utils/constants";
import BaseTag from "@/components_v2/Tags/BaseTag";
import { RoleBadgeTagProps } from "./types";

const RoleBadgeTag = ({ role }: RoleBadgeTagProps) => {
  const roleValue = OrganizationRoles.getItemByValue(role);

  return (
    <BaseTag
      style={{ backgroundColor: "#405dab33" }}
      className="role-badge"
      label={roleValue.label}
      size="extra-small"
      hasRoundCorners
    />
  );
};

export default RoleBadgeTag;
